import AbstractEntity from "../AbstractEntity";

export default class LegalDocument extends AbstractEntity {
    static STATUS_WAITING_FOR_PROVIDE = 0;
    static STATUS_PROVIDED = 1;
    static STATUS_REFUSED = 2;
    static STATUS_ACCEPTED = 3;
    static STATUS_END_OF_LIFE = 4;
    static STATUS_EXPIRED = 5;

    _id;
    _documentId;
    _status;
    _providedAt;
    _acceptedAt;
    _refusedAt;
    _refuseReason;
    _expireAt;
    _createdAt;
    _legalDocumentTemplateId;
    _companyId;
    _renewalOfLegalDocumentId;

    getId() {
        return this._id;
    }

    getDocumentId() {
        return this._documentId;
    }

    getStatus() {
        return this._status;
    }

    getProvidedAt() {
        return this._providedAt;
    }

    getAcceptedAt() {
        return this._acceptedAt;
    }

    getRefusedAt() {
        return this._refusedAt;
    }

    getRefuseReason() {
        return this._refuseReason;
    }

    getExpireAt() {
        return this._expireAt;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getLegalDocumentTemplateId() {
        return this._legalDocumentTemplateId;
    }

    getCompanyId() {
        return this._companyId;
    }

    getRenewalOfLegalDocumentId() {
        return this._renewalOfLegalDocumentId;
    }

    getClassName() {
        return "legal_document";
    }
}